<template>
    <div class="order-manage-details">
        <a-card :bordered="false">
            <a-skeleton :loading="loading" active>
                <a-card title="基本信息" :bordered="false">
                    <div class="grids">
                        <div>
                            <span>订单编号:</span>
                            <span>{{ data.sNo }}</span>
                        </div>
                        <div>
                            <span>订单类型:</span>
                            <span>{{ data.grText }}</span>
                        </div>
                        <div>
                            <span>订单状态:</span>
                            <span>{{ data.r_status }}</span>
                        </div>
                        <div v-if="data.otype != 'VI'">
                            <span>配送费用:</span>
                            <span v-if="data.freight > 0">{{ data.freight }}</span>
                            <span v-else>免邮</span>
                        </div>

                        <div>
                            <span>订单来源:</span>
                            <span v-if="data.source == 1">微信小程序</span>
                            <span v-else>App</span>
                        </div>
                        <div>
                            <span>支付方式:</span>
                            <span>{{ data.paytype }}</span>
                        </div>
                        <div>
                            <span>下单时间:</span>
                            <span v-if="data.add_time">{{ data.add_time }}</span>
                            <span v-else>暂无</span>
                        </div>
                        <div>
                            <span>付款时间:</span>
                            <span v-if="data.pay_time">{{ data.pay_time }}</span>
                            <span v-else>暂无</span>
                        </div>

                        <div>
                            <span>发货时间:</span>
                            <span v-if="data.deliver_time">{{ data.deliver_time }}</span>
                            <span v-else>暂无</span>
                        </div>
                        <div v-if="data.otype != 'VI'">
                            <span>快递单号:</span>

                            <template v-if="data.Orderlist === '暂无'">
                                <span>{{ data.Orderlist }}</span>
                            </template>

                            <template>
                                <span v-for="(item,i) in data.Orderlist"
                                      :key="i">{{ item.num }} {{ item.kuaidi_name }}</span>
                            </template>

                        </div>
                        <div v-if="data.otype != 'VI'">
                            <span>收货时间:</span>
                            <span v-if="data.arrive_time">{{ data.arrive_time }}</span>
                            <span v-else>暂无</span>
                        </div>
						<div>
						    <span>会员ID:</span>
						    <span>{{ data.user_id }}</span>
						</div>
						<div>
						    <span>会员名称:</span>
						    <span>{{ data.user_name }}</span>
						</div>
                        <div>
                            <span>订单备注:</span>
                            <span>{{ data.remarks }}</span>
                        </div>
                    </div>
                </a-card>
            </a-skeleton>


            <a-divider v-if="consigneeshow && data.otype != 'VI'"/>

            <template v-if="consigneeshow && data.otype != 'VI'">
                <a-skeleton :loading="loading" active>
                    <a-card title="收货人信息" :bordered="false">
                        <a-form :form="form" class="takedata">

                            <a-form-item label="收货人">
                                <a-input style="width:370px;" v-model="data.name"/>
                            </a-form-item>

                            <a-form-item label="联系电话">
                                <a-input style="width:370px;" v-model="data.mobile"/>
                            </a-form-item>

                            <a-form-item label="所在区域">
                                <a-cascader
                                        style="width:370px;"
                                        :options="city"
                                        placeholder="请选择所在地区"
                                        @change="onChange"
                                        :default-value="defaultCity"
                                />
                            </a-form-item>

                            <a-form-item label="详细地址">
                                <a-input style="width:370px;" v-model="data.address"/>
                            </a-form-item>

                            <a-form-item label="备注信息" v-if="data.r_status=='待付款'?false:true">
                                <a-textarea
                                        style="width:370px;"
                                        placeholder="备注信息"
                                        autosize
                                        v-model="data.remarks"
                                        :autosize="{ minRows: 2, maxRows: 6 }"
                                />
                            </a-form-item>
                        </a-form>

                    </a-card>
                </a-skeleton>
            </template>
			
            <a-divider/>


            <a-card title="商品信息" :bordered="false">
                <a-table :columns="columns" :dataSource="dataSource" :loading="loading"  :pagination="false" style="margin: 40px 20px 0;">

					  <span slot="name" slot-scope="text, record">
						<img class="nameimg" :src="record.pic" :alt="record.p_name">
						<span>{{ record.p_name }}</span>
					  </span>

								<!--          <span slot="sumup" slot-scope="text, record, index">-->
								<!--            <div class="sumups" :style="{ height: heights,flexDirection: 'column' }" style="white-space: nowrap;" v-if="index == 0">-->
								<!--                <p style="margin-bottom: 0;">{{userpar.z_price}}</p>-->
								<!--				-->
								<!--				<span class="small" v-if="data.otype == 'GM' || data.otype == ''">(店铺优惠：{{preferential_amount}})</span>-->
								<!--				<span class="small" v-if="data.otype == 'GM' || data.otype == ''">(平台优惠：{{coupon_price}})</span>-->
								<!--				<span class="small" v-else>(优惠金额：{{coupon_price}})</span>-->
								<!--    &lt;!&ndash;            <div>&ndash;&gt;-->
								<!--    &lt;!&ndash;              <a-input-number id="inputNumber" :min="0.01" v-model="userpar.z_price" />&ndash;&gt;-->
								<!--    &lt;!&ndash;            </div>&ndash;&gt;-->
								<!--            </div>-->
								<!--          </span>-->


								<span slot="freight" slot-scope="text, record">

						<template v-if="record.freight">
						  {{ record.freight }}
						</template>
						<template v-else>
						  免邮费
						</template>
					  </span>
								<span slot="z_price" slot-scope="text, record">
						{{ imputedPrice(record) }}
					  </span>
			
                </a-table>

                <div class="note">
                    <p><span>商品总价：</span> <span>￥{{goodsPrice.toFixed(2)}}</span></p>
                    <p v-if="data.otype != 'VI'"><span>运费：</span> <span>￥{{all_freight.toFixed(2)}}</span></p>
                    <p v-if="(data.otype == 'GM' || data.otype == '' || data.otype == 'VI') && Number(coupon_price)>0"><span>店铺优惠：</span> <span>- ￥{{coupon_price}}</span></p>
                    <p v-if="(data.otype == 'GM' || data.otype == '' || data.otype == 'VI') && discount_type"><span>{{discount_type}}优惠：</span> <span>- ￥{{preferential_amount}}</span></p>
                    <p v-if="grade_rate!=0"><span>会员折扣：</span> <span>- ￥{{grade_rate_amount.toFixed(2)}}</span></p>
					<p v-if="data.otype != 'GM' && data.otype != '' && data.otype != 'VI'"><span>优惠金额：</span> <span>- ￥{{coupon_price}}</span></p>
                    <p class="bold"><span>合计支付：</span>
                        <a-input v-if="data.r_status=='待付款'" style="width: 45%" type="number" v-model="userpar.z_price" />
                        <span class="red" v-else>￥{{userpar.z_price}}</span>
                    </p>
                </div>

            </a-card>

            <div class="foot">
                <a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
                <a-button type="primary" @click="onPreserve">保存</a-button>
            </div>
        </a-card>
    </div>
</template>

<script>
    import {city} from '../../assets/js/cityJson'

    const columns = [
        {
            key: 'id',
            title: '商品名称',
            scopedSlots: {customRender: 'name'},
        },
        {
            key: 'size',
            title: '商品规格',
            dataIndex: 'size'
        },
        {
            key: 'p_id',
            title: '商品编号',
            dataIndex: 'p_id'
        },
        {
            key: 'p_price',
            title: '单价',
            dataIndex: 'p_price',
            scopedSlots: {customRender: 'p_price'}
        },
        {
            key: 'num',
            title: '数量',
            dataIndex: 'num'
        },
        // {
        //     key: 'freight',
        //     title: '运费',
        //     scopedSlots: {customRender: 'freight'},
        // },
        {
            key: 'z_price',
            title: '小计',
            scopedSlots: {customRender: 'z_price'}
        },
        // {
        //   key: 'sumup',
        //   title: '总金额',
        //   scopedSlots: { customRender: 'sumup' },
        // }
    ];

    export default {
        data() {
            return {
                columns,
                dataSource: [],
                form: this.$form.createForm(this, {name: "coordinated"}),
                loading: true,
                consigneeshow: true,
                data: {},
                heights: '',
                userpar: {},
                city,
                defaultCity: [],
                coupon_price: 0,
                preferential_amount: 0,
                all_freight: 0,
                goodsPrice: 0,
				discount_type: '',
                remarks: '',
                grade_rate:0,
                grade_rate_amount: 0,
            }
        },
        watch: {
            dataSource: function (val) {
                this.heights = val.length * 92 + 'px'
            }
        },
        mounted() {
            this.httpInits()
        },
        methods: {
            onChange(val) {
                console.log(val)
                if (val.length == 0) {
                    this.data.sheng = ''
                    this.data.shi = ''
                    this.data.xian = ''
                } else {
                    this.data.sheng = val[0]
                    this.data.shi = val[1]
                    this.data.xian = val[2]
                }
            },
            onPreserve() {
                let {userpar, data} = this
                if (data.sheng == '' || data.shi == '' || data.xian == '' || data.address == '') {
                    this.$message.warning('请完善地址信息')
                    return;
                }
                let datas = {

                    where: {
                        sNo: userpar.sNo,
                        status: userpar.status,
                    },

                    updata: {
                        status: userpar.status,
                        name: data.name,
                        mobile: data.mobile,
                        address: data.address,
                        z_price: userpar.z_price,
                        remarks: data.remarks
                    },
                    oid: userpar.sNo,
                    sheng: data.sheng,
                    shi: data.shi,
                    xian: data.xian
                }
                this.$request.post('?module=pc_api&action=order&m=edit', datas).then(res => {
                    let {code, message} = res

                    if (code == 200) {
                        this.$message.success(message)

                        setTimeout(() => {
                            this.onGoBack()
                        }, 800)

                    } else {
                        this.$message.warning(message)
                    }
                })
            },
            /**
             * @name 返回
             * */
            onGoBack() {
                this.$router.go(-1)
            },
            onInputChange(val) {
                console.log(val)
            },
            /**
             * @name 初始页面数据
             */
            httpInits() {
                this.loading = true
                let {params} = this.$route
                params.type = 'updata'
                console.log(params)
                this.$request.get('?module=pc_api&action=order&m=edit_show', {params}).then(res => {

                    let {code, message, data} = res

                    if (code === 200) {
                        this.defaultCity = [data.detail[0].sheng, data.detail[0].shi, data.detail[0].xian]
						data.data.address = data.data.r_address
                        Object.assign(this, {
                            dataSource: data.detail,
                            userpar: data.detail[0],
                            coupon_price: data.coupon_price,
                            preferential_amount: data.preferential_amount,
							discount_type: data.discount_type,
                            grade_rate: data.grade_rate,
                            grade_rate_amount: data.grade_rate_amount,
                        })

                        data.detail.map( item =>{
                            this.goodsPrice += parseFloat(item.p_price)* parseInt(item.num)
                            this.all_freight += parseFloat(item.freight)
                        })


                        this.isState(data.data)
                        setTimeout(() => {
                            this.loading = false
                        }, 600)
                    }
                })
            },
            /**
             * @name 订单状态判断
             */
            isState(data) {
                // status01: 6|已关闭 2|待收货
                let {status01} = data

                const State = (code) => {
                    const status = new Map([
                        ['0', true],
                        ['1', true],
                        ['2', true],
                        ['3', true],
                        ['4', true],
                        ['5', true],
                        ['6', false],
						['7', true],
						['8', true],
						['9', true],
						['10', true],
                    ])
                    return status.get(code)
                }

                this.isOrderType(data)
                this.getOrderCode(data)

                Object.assign(this, {
                    consigneeshow: State(status01),
                    data: data
                })
            },
            /**
             * @name 判断订单类型
             */
            isOrderType(data) {
                if (data.otype == 'pt') {
                    data.grText = '拼团订单'
                } else if (data.otype == 'JP') {
                    data.grText = '竞拍订单'
                } else if (data.otype == 'integral') {
                    data.grText = '积分订单'
                } else {
                    if (data.drawid > 0) {
                        data.grText = '抽奖订单'
                    } else {
                        data.grText = '正价订单'
                    }
                }
            },
            /**
             * @name 总价计算
             */
            imputedPrice(record) {
                let {num, p_price, freight} = record
                return (parseFloat(p_price) * Number(num) + parseFloat(freight)).toFixed(2)
            },
            /**
             * @name 获取订单编号
             */
            getOrderCode(data) {
                if (data.fh == 0) {
                    data.Orderlist = '暂无'
                } else {
                    data.Orderlist = data.courier_num
                }
            },
            onInputNumberChange(value) {
                console.log("changed", value);
            },
            onCascaderChange(value) {
                console.log("changed", value);
            }
        }
    };
</script>

<style lang="less" scoped>
	
    .order-manage-details {
        height: 85vh;
        overflow-y: auto;

        .grids {
            padding: 40px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 30px;

            div {
                span:nth-child(even) {
                    color: #323544;
                    font-size: 14px;
                }

                span:nth-child(odd) {
                    color: #828b97;
                    font-size: 14px;
                }
            }
        }

        .takedata {
            padding: 40px;
        }

        .nameimg {
            width: 60px;
            height: 60px;
        }

        .foot {
            height: 68px;
            width: 100%;
            border-top: 1px solid #e9ecef;
            position: sticky;
            bottom: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0px 60px;
            background: #ffffff;
            z-index: 9992;

            .btns {
                margin-right: 10px;
            }
        }
    }

    .sumups {
        position: absolute;
        top: 54px;
        width: 7.2%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .note {
        width: 200px;
        float: right;
        margin-top: 20px;
		margin-right: 20px;

        p {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
        }

        p.bold {
            font-weight: bold;
			display: flex;
			align-items: center;

            .red {
                color: red;
            }
        }
    }
</style>